import { BarChart2 } from 'lucide-react';
import { Breadcrumb } from '@/components/ui/breadcrumb';

interface ReportPageProps {
  reportName: string;
}

export function ReportPage({ reportName }: ReportPageProps) {
  const breadcrumbItems = [
    { label: 'Reports' },
    { label: reportName },
  ];

  return (
    <div className="flex flex-col h-full">
      {/* Header */}
      <div className="flex items-center gap-3 px-6 py-4 border-b border-border shrink-0">
        <div className="flex items-center gap-3 flex-1 min-w-0">
          <div className="flex items-center justify-center h-8 w-8 rounded-md bg-teal-600/10 shrink-0">
            <BarChart2 className="h-4 w-4 text-teal-600" />
          </div>
          <div className="min-w-0">
            <Breadcrumb items={breadcrumbItems} className="mb-0.5" />
            <h1 className="text-lg font-semibold text-foreground leading-tight mt-0.5">
              {reportName}
            </h1>
          </div>
        </div>
      </div>

      {/* Body */}
      <div className="flex-1 overflow-auto p-6">
        <div className="flex flex-col items-center justify-center h-full min-h-[320px] gap-4 text-center">
          <div className="flex items-center justify-center h-16 w-16 rounded-2xl bg-muted">
            <BarChart2 className="h-8 w-8 text-muted-foreground" />
          </div>
          <div className="space-y-1">
            <p className="text-base font-medium text-foreground">{reportName}</p>
            <p className="text-sm text-muted-foreground max-w-xs">
              This report is coming soon. Check back later for data and insights.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
